export default function ProductName({ children }: { children: JSX.Element | string }) {
    return <div>{children}</div>;
}